// Give-back (ເງິນປັນຜົນ) display constants — labels for the 7 server-computed
// lines. Amounts always render verbatim from the API; never recompute client-side.
export const GIVE_BACK_BUCKET_LABELS = {
    receive_origin: "ສ້າງຕົ້ນທາງ",
    receive_cdc_success: "ສ້າງ CDC ສຳເລັດ",
    success_origin: "ຈັດສົ່ງສຳເລັດຕົ້ນທາງ",
    success_cdc: "ຈັດສົ່ງສຳເລັດ CDC (ພາຍໃນ)",
    success_cdc_thailand: "ຈັດສົ່ງສຳເລັດ ໄທ",
    success_cdc_china: "ຈັດສົ່ງສຳເລັດ ຈີນ",
    success_cdc_vietnam: "ຈັດສົ່ງສຳເລັດ ຫວຽດນາມ",
};

export const GIVE_BACK_STATUS_LABELS = {
    ready: "ພ້ອມແລ້ວ",
    cached: "ຍອດແຄສ (≤48 ຊມ)",
    computing: "ກຳລັງຄິດໄລ່...",
    no_owner: "ບໍ່ມີຂໍ້ມູນເຈົ້າຂອງ",
};
